import React, { useEffect } from 'react';
import styled from 'styled-components';

import Details from './Details';

import Breadcrumbs from './Breadcrumbs';

import About from './About';

//Toastify Components
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Seo from "../templates/Seo/seo"


const Wrapper = styled.div`
    padding-top: 10vw;
    width: 100%;
    background-color: var(--lightgreen);

    display: flex;
    flex-direction: column;
    align-items: center;


    @media(max-widtH: 1000px)
    {
        padding-top: 15vh;
        .breadcrumbs{
            width: 90%;
            font-size: 1.75vh;
        }
    }
`;

const Revalidate = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, .6);
    z-index: 10;
    font-size: 40px;
    text-shadow: 1px 1px 2px;
`

export default function TotalProductPage({ product, loading }) {

    useEffect(() => {
        if(loading) document.body.style.overflow = "hidden"
        else document.body.style.overflow = ""
    },[loading])

    const seo = {
      metaTitle: product?.name,
      description: product?.description,
      keywords: product?.name + ' ' + product?.description + ' ' + product?.effects?.join(" ")
    };

    const SEOSchema = {
      "@context": "http://www.schema.org",
      "@type": "product",
      "brand": product ? product?.brand.name : 'weed brand',
      "name": product ? product?.name : 'weed name',
      "image": product ? product?.image : 'weed image',
      "description": product ? product?.description : 'weed description',
      "offers": {
        "@type": "Offer",
        "url": "",
        "priceCurrency": "CAD",
        "price": product?.variants ? product?.variants[0].price_rec : '10.00'
      }
    }

    return(
      <>
        <Seo
          title={seo.metaTitle}
          description={seo.metaDescription}
          keywords={seo.keywords}
          schemaMarkup={SEOSchema}
        />
        <Wrapper>
          {loading && <Revalidate>Revalidating...</Revalidate>}
          <Breadcrumbs product={product}/>

          <Details product={product}/>

          {/* <AvailableAt product={product}/> */}

          <About product={product}/>
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            newestOnTop={false}
            closeOnClick={true}
            pauseOnHover={false}
          />
        </Wrapper>
      </>
    )
}